import * as React from 'react';
import { styled } from '@mui/material/styles';
import classNames from 'classnames';

const classes = {
  disabled: 'disabled',
};

const Root = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
  maxWidth: 600,
  minHeight: 180,

  [`&.${classes.disabled}`]: {
    opacity: theme.palette.action.disabledOpacity,
    pointerEvents: 'none',
  },
}));

interface Props {
  className?: string;
  disabled?: boolean;
}

export const BraintreeDropIn = React.forwardRef<HTMLDivElement, Props>(({ className, disabled }, ref) => {
  return <Root className={classNames(className, { [classes.disabled]: disabled })} id="dropin-container" ref={ref} />;
});
